import { render } from "./CreateRequest5.vue?vue&type=template&id=d2306904"
import script from "./CreateRequest5.vue?vue&type=script&lang=js"
export * from "./CreateRequest5.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__